import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticFeaturedProjects = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findFeaturedProjectsSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useFeaturedProjectsQuery {
		squidex {
			findFeaturedProjectsSingleton {
				id
				data {
					list {
						iv {
							project {
								id
							}
						}
					}
				}
			}
		}
	}
`;
